<avatar-list (selectionChanged)="onSelectCustomer($event)" [appearance]="appearance" [availableElements]="_customers"
             [enabled]="true" [placeholder]="'Customer'" [staticAvatar]="_staticAvatar" [type]="'customer'"
></avatar-list>